export default class IframeHelper {
    static updateHeight(host, url) {
        const body = document.body;

        const height = body.scrollHeight;

        const data = {
            height: height,
            data: {
                height: height
            }
        };

        if (url) {
            data['url'] = url;
            data['data']['url'] = url;
        }

        if (IframeHelper.isInIframe()) {
            window.parent.postMessage(JSON.stringify(data), host);
        }
    }

    static getUrlWithFilters(url, encodedFilters) {
        let parts = url.split('/');
        for(let i = 0; i < parts.length; i++) {
            if (parts[i].indexOf('?') >= 0) {
                parts[i] = parts[i].split('?')[0];
            }

            if (parts[i].indexOf('wfilter') === 0) {
                parts.splice(i, 1);
            }
        }

        let separator = '/';
        if (parts.join('/').slice(-1) === '/') {
            separator = '';
        }

        return `${parts.join('/')}${separator}wfilter:${encodedFilters}`;
    }

    static link(parameters, path) {
        if (parameters['iframe']) {
            if (parameters['projectUrl'].indexOf('?') !== -1) {
                return parameters['projectUrl'] + '&wurl=' + path;
            }

            return parameters['projectUrl'] + '?wurl=' + path;
        } else {
            return parameters['projectUrl'] + path;
        }
    }

    static isInIframe() {
        return window.location !== window.parent.location;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/IframeHelper.js